<template>
    <v-list-item @click="$emit('click', $event)" :class="{ active: active }">
        <v-checkbox :input-value="active"></v-checkbox>

        <v-list-item-icon>
            <v-icon
                :class="{
                    'appbar-icon-button btn-bg-color-dark-blue white--text': active && !orange,
                    'appbar-icon-button btn-bg-color-blue dark-blue-color': (!active && !orange) || parent,
                    'appbar-icon-button btn-bg-color-navbar-petfood': active && orange,
                    'appbar-icon-button btn-bg-color-navbar-petfood-inactive dark-blue-color': !active && orange,
                }"
            >
                {{ icon }}
            </v-icon>
        </v-list-item-icon>

        <v-list-item-content class="ml-3">
            <p class="font-size-md dark-blue-color" :class="{ 'mb-0': !canViewIdAndCompanyBranch }">{{ name }}</p>

            <v-list-item-subtitle v-if="canViewIdAndCompanyBranch" class="font-size-sm">
                {{ id }}
            </v-list-item-subtitle>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
import { mapStores } from 'pinia';
import { useUserStore } from '@/Stores/user';

export default {
    props: {
        icon: String,
        name: String,
        id: String,
        active: Boolean,
        orange: Boolean,
        parent: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        ...mapStores(useUserStore),

        canViewIdAndCompanyBranch() {
            if (this.id == null) {
                return false;
            }

            return this.userStore.hasPermissionTo('View client and branch number');
        },
    },
};
</script>

<style scoped>
.active {
    background-color: #e9f7fd;
}
</style>
<style>
/* Keeping in case the client requests a specific border for the "parent" items */
/* .v-icon.outlined {
    border: 1px solid #e9f7fd;
} */
</style>
